import React from 'react'
import ContactUs from '../Components/ContactUs/ContactUs'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import RegisterBook from '../Components/RegisterBook/RegisterBook'
import SteperBooking from '../Components/SteperBooking/SteperBooking'
import TopNavbar from '../Components/TopNavbar/TopNavbar'

const RegisterBooking = () => {
  return (
    <>
    <TopNavbar/>
    <Header/>
  
<RegisterBook/>
<ContactUs/>
    <Footer/>
    </>
  )
}

export default RegisterBooking